import { render, staticRenderFns } from "./RequestedNotification.vue?vue&type=template&id=d727393a&"
import script from "./RequestedNotification.vue?vue&type=script&lang=js&"
export * from "./RequestedNotification.vue?vue&type=script&lang=js&"
import style0 from "./RequestedNotification.vue?vue&type=style&index=0&id=d727393a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports